import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, TenantDto, TenantReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import TenantInline, { TenantInlineProps } from "./TenantInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: TenantDto | TenantReferenceDto | null | undefined;
  entityId: string | null | undefined;
  inlineProps?: Partial<TenantInlineProps>;
}

export default function TenantLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.TenantRead]}
      to={ROUTE_PATH.TENANT_VIEW(entity?.id || entityId || "")}
      content={<TenantInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
